/// <amd-module name="TFS/Admin/Views/ProfileSettings/AuthorizationsView/Components/RevokeAppAuthDialog" />
import React = require("react");
import * as Resources from "TFS/Admin/Views/ProfileSettings/AuthorizationsView/Resources";

import { filterXSS } from "xss";
import { IRevokeAppAuthDialogProps } from "TFS/Admin/Views/ProfileSettings/AuthorizationsView/Contracts/DataModel";
import { FormatComponent } from "VSS/Platform/Components/Format";
import { Dialog } from "VSSUI/Dialog";

export class RevokeAppAuthDialog extends React.Component<IRevokeAppAuthDialogProps> {
    public render() {
        return (
            <Dialog
                titleProps={{ text: Resources.RevokeDialogTitle }}
                onDismiss={() => this.props.onDismiss()}
                footerButtonProps={[
                    {
                        text: Resources.Cancel,
                        onClick: () => this.props.onDismiss()
                    },
                    {
                        disabled: false,
                        danger: true,
                        text: Resources.Revoke,
                        onClick: () => this.props.onRevoke()
                    }
                ]}
            >
                <p>{Resources.RevokeAppMessageOne}</p>
                <FormatComponent format={Resources.RevokeAppMessage}>
                    <span className="font-weight-heavy">{filterXSS(this.props.appName)}</span>
                </FormatComponent>
            </Dialog>
        );
    }
}
